<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <div class="gpopup">
    <div class="gpopup-backdrop" @mousedown.prevent="overlayClick" />
    <div class="gpopup-container" :class="item?.containerClass">
      <div class="gpopup-header" :class="item?.headerClass">
        <component :is="item?.title.tag || 'h3'" :class="item?.title.class">{{ item?.title.text }}</component>
      </div>
      <div class="gpopup-body" :class="item?.bodyClass">
        <component :is="item?.content.tag || 'p'" :class="item?.content.class" v-html="item?.content.text"></component>
      </div>
      <div v-if="item?.actions" class="gpopup-footer" :class="item?.footerClass">
        <component
          :is="item?.actions.primary.tag || 'button'"
          v-if="item?.actions.primary"
          :class="item?.actions.primary.class"
          v-bind="item?.actions.primary.attrs"
          @click="primaryAction"
          v-html="item?.actions.primary.text" />
        <component
          :is="item?.actions.secondary.tag || 'button'"
          v-if="item?.actions.secondary"
          :class="item?.actions.secondary.class"
          v-bind="item?.actions.secondary.attrs"
          @click="secondaryAction"
          v-html="item?.actions.secondary.text" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Popup',
  props: {
    item: Object,
  },
  computed: {},
  methods: {
    overlayClick() {},
    closeDialog() {
      this.$emit('close', this.item?.id);
    },
    primaryAction() {
      if (typeof this.item?.actions?.primary?.action == 'function') {
        const shouldClose = this.item?.actions.primary.action(this.closeDialog);
        if (shouldClose) {
          this.closeDialog();
        }
      }
    },
    secondaryAction() {
      if (typeof this.item?.actions?.secondary?.action == 'function') {
        const shouldClose = this.item?.actions.secondary.action(this.closeDialog);
        if (shouldClose) {
          this.closeDialog();
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/color';

$baseIndex: $modalIndex;
.gpopup {
  position: fixed;
  z-index: $baseIndex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  @include flex-center;

  &-backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background: rgba(#000, 0.5);
  }

  &-container {
    position: relative;
    background: $light3;
    min-width: 424px;
    @media screen and (max-width: 576px) {
      min-width: unset;
    }
    max-height: 100vh;
    // height: 600px;
    display: flex;
    z-index: 10;
    flex-direction: column;
    border-radius: $radius;

    &_header {
      position: relative;
      // align-items: center;
      // display: flex;
    }

    &_actions {
      position: relative;
    }

    &_body {
      max-height: calc(100vh - 160px);
      overflow: overlay;
      @-moz-document url-prefix() {
        overflow: auto;
      }
    }
  }

  &-close {
    z-index: 1;
    position: absolute;
    top: 15px;
    right: 15px;
    display: flex;
    @include flex-center;
    // padding: 15px;
    // @include trans-all;
    color: $text-light-low;
    margin-left: auto;

    font-size: 18px;
    cursor: pointer;
    border-radius: $radius;
    // background: $light3;
    &:hover {
      color: $text-light-high;
      background: $text-dark-high;
    }
  }
}
</style>
